import {animate, animateChild, group, query, style, transition, trigger} from '@angular/animations';

export const routeAnimation = trigger('routeAnimations', [
  transition('* => animationChild', [
    style({position: 'relative', overflow: 'hidden'}),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          'z-index': '60',
          'min-height': '100%',
        }),
      ],
      {optional: true},
    ),
    query(
      ':leave',
      [
        style({
          opacity: '1',
          'z-index': '-1',
        }),
      ],
      {optional: true},
    ),
    query(
      ':enter',
      [
        style({
          transform: 'translateX(100%)',
          'box-shadow': '0 0 0 0 rgba(0,0,0,0)',
          opacity: 0,
        }),
      ],
      {optional: true},
    ),
    query(':leave', animateChild(), {optional: true}),
    group([
      query(
        ':enter',
        [
          animate(
            '.8s cubic-bezier(.16,.78,.26,.99)',
            style({
              transform: 'translateX(0)',
              'box-shadow': '0 0 40px 0 rgba(0,0,0,0.2)',
              opacity: '1',
            }),
          ),
        ],
        {optional: true},
      ),
      query(
        ':leave',
        [
          animate(
            '.6s cubic-bezier(.16,.78,.26,.99)',
            style({
              opacity: '0',
            }),
          ),
        ],
        {optional: true},
      ),
    ]),
    query(':enter', animateChild(), {optional: true}),
  ]),
  transition('animationChild => *', [
    style({position: 'relative', overflow: 'hidden'}),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          'background-color': '#F5F6FA',
          'min-height': '100%',
        }),
      ],
      {optional: true},
    ),
    query(
      ':enter',
      [
        style({
          opacity: 0,
          'z-index': '-1',
        }),
      ],
      {optional: true},
    ),
    query(
      ':leave',
      [
        style({
          'z-index': '60',
        }),
      ],
      {optional: true},
    ),
    query(':leave', animateChild(), {optional: true}),
    group([
      query(
        ':enter',
        [
          animate(
            '.8s cubic-bezier(.16,.78,.26,.99)',
            style({
              opacity: '1',
            }),
          ),
        ],
        {optional: true},
      ),
      query(
        ':leave',
        [
          animate(
            '.6s cubic-bezier(.16,.78,.26,.99)',
            style({
              transform: 'translateX(100%)',
              'box-shadow': '0 0 40px 0 rgba(0,0,0,0.2)',
            }),
          ),
        ],
        {optional: true},
      ),
    ]),
    query(':enter', animateChild(), {optional: true}),
  ]),
  transition('login => *', [
    // DISABLED
  ]),
  transition('* => *', [
    style({position: 'relative', 'background-color': '#243145', overflow: 'hidden'}),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          'background-color': '#F5F6FA',
          'min-height': '100%',
        }),
      ],
      {optional: true},
    ),
    query(
      ':enter',
      [
        style({
          transform: 'translateX(100%)',
          'box-shadow': '0 0 0 0 rgba(0,0,0,0)',
          'z-index': '80',
        }),
      ],
      {optional: true},
    ),
    query(':leave', animateChild(), {optional: true}),
    group([
      query(
        ':enter',
        [
          animate(
            '1s cubic-bezier(0.86, 0, 0.07, 1)',
            style({
              transform: 'translateX(0)',
              'box-shadow': '0 0 100px 0 rgba(0,0,0,0.5)',
            }),
          ),
        ],
        {optional: true},
      ),
      query(
        ':leave',
        [
          animate(
            '1s cubic-bezier(.16,.78,.26,.99)',
            style({
              transform: 'scale(0.85)',
              opacity: '0.3',
            }),
          ),
        ],
        {optional: true},
      ),
    ]),
    query(':enter', animateChild(), {optional: true}),
  ]),
]);
